










































































































































































































import {Component, Prop, Watch, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Lesson from '../api/lesson';
import Exercise from '../api/exercise';
import ApiList from '@/api/list';

import Modal from '@/components/Modal.vue';
import DropDownEntity from '@/components/DropDownEntity.vue';
import FieldTextRange from '../components/FieldTextRange.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import FieldAudio from '@/components/FieldAudio.vue';
import NextExercise from '../api/nextExercise';
import Media from '../api/media';
import FieldInternational from "@/components/FieldInternational.vue";
import FieldMetricPoints from "@/components/FieldMetricPoints.vue";

@Component({
    components: {
        'field-international': FieldInternational,
        'field-metric-points': FieldMetricPoints,
        'modal': Modal,
        'drop-down-entity': DropDownEntity,
        'field-text-range': FieldTextRange,
        'edit-icon': EditIcon,
        'field-audio': FieldAudio,
    },
})
export default class FieldAltNextExercise extends CommonVue {
    @Model() public nextExercises!: NextExercise[];
    @Prop({type: String}) public sentence!: string;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Number}) public moduleId!: number;
    @Prop({type: Number}) public exerciseId!: number;
    @Prop({type: Number}) public lessonId!: number;

    public nextExercise: NextExercise = null;
    public showModal: boolean = false;
    public lessonList: ApiList<Lesson> = null;
    public exerciseList: ApiList<Exercise> = null;
    public lessonWatch: Lesson = null;

    public async beforeMount() {
        this.busy = true;
        this.error = false;

        await this.loadLessonList();

        this.busy = false;
    }

    public async loadLessonList() {
        try {
            this.lessonList = await Lesson.getLessonsOfModule(this.moduleId);
        } catch (e) {
            this.$bus.$emit(BusEvent.ERROR, 'Could not load lessons list', e);
            this.error = true;
        }
    }

    @Watch('nextExercise.lesson')
    public async loadExerciseList() {
        try {
             if(this.nextExercise.lesson === 0){
                this.nextExercise.lesson = this.lessonId;
            }
            this.exerciseList = await Exercise.getExercisesOfLesson(this.nextExercise.lesson);
            this.addEndToExercise();
        } catch (e) {
            this.$bus.$emit(BusEvent.ERROR, 'Could not load exercises list', e);
            this.error = true;
        }
    }

    public async addEndToExercise() {
        for (const item of this.exerciseList.results){
                item.id = '' + item.id
        }
        let exercise = new Exercise();
        exercise.id = 'END';
        await this.exerciseList.results.push(exercise);
    }

    public newNextExercise() {
        this.nextExercise = new NextExercise();
        this.showModal = true;
        this.getLesson();
    }

    public edit(nextExercise: NextExercise) {
        this.nextExercise = nextExercise;
        this.showModal = true;
        this.getLesson();
    }

    public async getLesson() {
        // this.lessonWatch = await Lesson.get(this.nextExercise.lesson);
        this.lessonWatch = await Lesson.get(this.lessonId);
    }

    public saveClicked() {
        if (!this.nextExercise) {
            return;
        }

        this.busy = true;
        try {
            // this.checkMandatoryFields();
            if (this.nextExercise.state === 'created') {
                this.nextExercises.push(this.nextExercise);
            }
            this.nextExercise.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save next exercise', e);
        }
    }

    public checkMandatoryFields() {
        if (!this.nextExercise.exercise) {
            throw Error('Please insert an exercise for your next exercise.');
        }

    }


    public deleteClicked() {
        this.nextExercise.state = 'deleted';
        this.showModal = false;
    }

    public isValidExerciseList(): boolean {
        // if the lesson only has this exercise return not valid
        if (this.exerciseList.results.length === 1 && this.exerciseList.results[0].id === this.exerciseId) {
            return false;
        }
        return this.exerciseList.results.length > 0;
    }

    public static async saveNextExercises(nextExercises: NextExercise[], parent_id: number, content_type: string): Promise<void> {
        for (let nextExercise of nextExercises) {
            if (nextExercise.state === 'updated') {
                nextExercise.parent_id = parent_id;
                nextExercise.parent_model = content_type;
                await FieldAltNextExercise.saveExercise(nextExercise);
            } else if (nextExercise.state === 'deleted') {
                nextExercise = new NextExercise().assign(nextExercise);
                await nextExercise.delete();
            }
        }

    }

    public static async saveExercise(exercise: NextExercise) {
        if (!exercise.id) {
            exercise.id = await exercise.save();
        }
        await FieldAltNextExercise.saveMediaFiles(exercise);
        exercise = new NextExercise().assign(exercise);
        await exercise.save();
    }

    public static async saveMediaFiles(exercise: NextExercise) {
        if (exercise.audio_file) {
            const audio = await Media.createAudio(
                exercise.audio_file,
                NextExercise.SLUG,
                exercise.id,
                'audio_path'
            );
            if (audio !== null) {
                exercise.audio = audio;
            }
        } else if (exercise.audio_file === null) {
            await Media.deleteAudio(exercise.audio);
            exercise.audio = undefined;
        }
        if (exercise.audio_alt_file) {
            const audio_alt = await Media.createAudio(
                exercise.audio_alt_file,
                NextExercise.SLUG,
                exercise.id,
                'audio_alt_path'
            );
            if (audio_alt !== null) {
                exercise.audio_alt = audio_alt;
            }
        } else if (exercise.audio_alt_file === null) {
            await Media.deleteAudio(exercise.audio_alt);
            exercise.audio = undefined;
        }
    }
}
